<div class="col-12 linear" align="center">
  <span style="position: relative;margin: 0 auto;top: 22%;">
    <img src="../../../../assets/img/sucesstick.svg" width="60px" style="margin-left: 10px;margin-top: 8px;" alt="">
  </span>
  <div class="ordermsg">Order Placed Successfully</div>
</div>


<style>
  .mat-bottom-sheet-container {
    padding: 0px !important;
    min-width: 100vw;
    box-sizing: border-box;
    display: block;
    outline: 0;
    overflow: auto;
  }

  @media only screen and (min-width: 600px) {
    .container {
      width: 350px;
      max-width: 100%;
    }

    ::ng-deep .mat-bottom-sheet-container-large {
      min-width: 380px !important;
      max-width: 380px;
    }
  }

  .linear {
    background-image:
      linear-gradient(151deg, #64B154 0%, #2B869E 100%);
    height: 230px;
    overflow: hidden;
  }

  .ordermsg {
    margin: 0 auto;
    top: 30%;
    position: relative;
    color: #ffffff;
    font-size: 18px;
    font-weight: 500;
  }

  ::ng-deep::-webkit-scrollbar {
    display: none !important;
  }

  ::ng-deep.mat-bottom-sheet-container-large {
    min-width: 380px;
    max-width: 380px;
    padding: 0px;
  }

  ::ng-deep.mat-bottom-sheet-container-xlarge {
    min-width: 380px !important;
    max-width: 380px;
    padding: 0px;
  }
</style>